import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetRsvpQuestionsAction } from '../../actions/rsvp-questions/get-rsvp-questions-action';
import { GetRsvpQuestionsSuccessAction } from '../../actions/rsvp-questions/get-rsvp-questions-success-action';
import { GetRsvpQuestionsErrorAction } from '../../actions/rsvp-questions/get-rsvp-questions-error-action';

@Injectable()
export class GetRsvpQuestionsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetRsvpActions = createEffect(() => this.actions
    .pipe(
      ofType(GetRsvpQuestionsAction.type),
      mergeMap(action => {
        const getRsvpQuestionsAction = <GetRsvpQuestionsAction>action;
        return this.api.getRsvpQuestions(getRsvpQuestionsAction.bijbEvent).then(rsvpQuestions => {
          return new GetRsvpQuestionsSuccessAction(rsvpQuestions.sort((a, b) => a.order - b.order));
        }, error => {
          return new GetRsvpQuestionsErrorAction(error);
        });
      })
    ));
}
